module.exports = __webpack_public_path__ + "img/home_video.6aa889e3.jpg";